import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';
import { useMemo } from 'react';

type ChartLoaderProps = {
    numberOfBars?: number;
    barMinHeight?: number;
    barMaxHeight?: number;
    hasYaxis?: boolean;
};

export const ChartLoader = ({
    numberOfBars = 10,
    barMinHeight = 10,
    barMaxHeight = 100,
    hasYaxis = false,
}: ChartLoaderProps) => {
    const loaders = useMemo(() => {
        const generateRandomHeight = () => Math.floor(Math.random() * (barMaxHeight - barMinHeight + 1) + barMinHeight);

        return Array.from({ length: numberOfBars }, (_, index) => ({
            id: index,
            height: generateRandomHeight(),
        }));
    }, [numberOfBars, barMinHeight, barMaxHeight]);

    return (
        <div className='position-relative'>
            {hasYaxis && (
                <ContentLoader className='position-absolute left-0 bottom-0 right-0' height='100%' width='1px' />
            )}
            <ContentLoader className='position-absolute left-0 bottom-0 right-0' height='1px' width='100%' />
            <div className='display-grid align-items-end gap-20' style={{ gridAutoFlow: 'column', minHeight: '260px' }}>
                {loaders.map(loader => (
                    <ContentLoader key={loader.id} className='margin-x-auto' height={`${loader.height}%`} width='50%' />
                ))}
            </div>
        </div>
    );
};
